import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["image-src"]
const _hoisted_2 = { class: "text-center mb-3 md:hidden" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("snap-button", {
  icon: "camera-solid",
  size: "xs",
  variant: "tertiary"
}, "Change ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-center" }, " A picture helps people recognize you and lets you know when you’re signed in to your account ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-sm my-4 p-4 bg-blue-50 border-2 border-gray-200 border-dashed rounded-xl" }, [
  /*#__PURE__*/_createElementVNode("snap-icon", {
    icon: "cloud-upload-solid",
    color: "#2563EB",
    "bg-color": "#ffffff",
    size: "xl",
    state: "rounded",
    class: "mb-2 border border-solid border-blue-600 rounded-full"
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, [
    /*#__PURE__*/_createTextVNode(" Drag & Drop Files or "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-blue-600 cursor-pointer" }, "Browse")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500" }, "Supported formats: PNG or JPG up to 5MB")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Upload = _resolveComponent("Upload")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.update()), ["prevent"]))
  }, [
    _createElementVNode("snap-avatar", {
      "image-src": _ctx.avatar,
      size: "profile-lg",
      class: "text-center block mb-2"
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Upload, {
        modelValue: _ctx.profilePicture,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.profilePicture) = $event)),
        validation: _ctx.v$.profilePicture,
        class: "inline-block cursor-pointer",
        accept: "image/*"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["modelValue", "validation"])
    ]),
    _hoisted_4,
    _createVNode(_component_Upload, {
      modelValue: _ctx.profilePicture,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.profilePicture) = $event)),
      validation: _ctx.v$.profilePicture,
      class: "hidden md:block",
      accept: "image/*"
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }, 8, ["modelValue", "validation"])
  ], 32))
}